var map = {
	"./bathtub.svg": 745,
	"./fountain.svg": 143,
	"./radiator.svg": 2364,
	"./shower.svg": 4815,
	"./tiles.svg": 2830,
	"./toilet.svg": 9006,
	"./utilities.svg": 1249,
	"./washbasin.svg": 7507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1931;